var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-level" }, [
    _c("div", { staticClass: "ellipsis search-result-item gray-100" }, [
      _c("span", [_vm._v("#" + _vm._s(_vm.data.id))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ellipsis search-result-item ml-2 gray-60" },
      [
        _c("chip-label", {
          attrs: { color: _vm.data.status.color, label: _vm.data.status.label }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ellipsis search-result-item ml-2 gray-60" }, [
      _c("span", [_vm._v(_vm._s(_vm.data.third))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ellipsis search-result-item ml-2 gray-60" }, [
      _c("span", [_vm._v(_vm._s(_vm.data.subject))])
    ]),
    _vm._v(" "),
    _vm.data.link
      ? _c("div", { staticClass: "flex-right" }, [
          _c("i", { staticClass: "icon-chevron-right gray-60" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }